import { defineComponent as _defineComponent } from 'vue'
import { MultiJumpContainer } from '@tencent/wphk-components-multi-jump-container';
import { Banner, ColumnType } from '@/types/banner-layout';


export default /*#__PURE__*/_defineComponent({
  __name: 'banner-list',
  props: {
    bannerList: null,
    columnType: null
  },
  setup(__props: any) {

const props = __props as {
  bannerList: Banner[];
  columnType: ColumnType;
}



return { __sfc: true,props, MultiJumpContainer }
}

})